<template>
  <div class="animated fadeIn">
    <div id="snackbar"></div>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong> Static Pages</strong>
            <small>Form</small>
          </div>
          <b-form v-on:submit.prevent.self="submitFinalData">
            <b-row>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    v-model="pagesList.main_name"
                    :disabled="$route.query.mpm_id ? true : false"
                    :options="pageList"
                    :multiple="false"
                    placeholder="Select Page"
                    @select="onSelectPage($event)"
                  ></multiselect>
                </b-form-group>
              </div>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    :options="LanguageArray"
                    :disabled="$route.query.mpm_id ? true : false"
                    :multiple="false"
                    track-by="lang_id"
                    label="lang_name"
                    placeholder="Select Language"
                    @select="languageSelect"
                    v-model="selectedLang"
                  ></multiselect>
                </b-form-group>
              </div>

              <div v-if="selectedPage.banner" class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
              
                  <input
                    name="image_arr"
                    ref="fileinput"
                    v-on:change="uploadBanner($event.target)"
                    accept="image/jpeg, image/png, image/gif"
                    type="file"
                    multiple
                    v-b-tooltip.hover.top="'Banners - Size: 1520*500'"
                  />
                  <input type="hidden" v-model="pagesList.banner" />
                </b-form-group>
                <div
                  style="cursor: pointer"
                  @click="seeImagesFill('banner', -1,'image')"
                  v-if="pagesList.banner"
                >
                  <u>See {{ pagesList.banner.split(",").length }} images</u>
                </div>
              </div>
              <b-form-checkbox v-if="selectedPage.banner"
                v-model="pagesList.status"
                unchecked-value="N"
                value="Y"
                class="j-checkbox ml-3 mb-3 mt-2"
              >
                Status
              </b-form-checkbox>
              <b-col sm="12" class="mt-3 mb-3">
                <h5>Other Data:</h5>
              </b-col>
            </b-row>

            <!-- DETAIL DATA PAGE -->

            <b-row
              class="m-2"
              v-for="(item, index) in pagesList.otherData"
              :key="index"
            >
              <div
                v-if="item.o_status == 'Y'"
                style="
                  padding: 5px;
                  border: 1px solid #968888;
                  border-radius: 5px;
                  width:100%
                "
              >
              <div class="d-flex ">
                <div v-if="selectedPage.main_name" class="col-lg-4 col-xl-3 align-self-center mb-2">
                  <b-form-group>
                    <div class="input-material mt-2">
                      <b-form-input
                        type="text"
                        v-model="item.main_name"
                        id="bannerURL"
                        placeholder="Main Name"
                      ></b-form-input>
                      <label>{{selectedPage.name}}</label>
                    </div>
                  </b-form-group>
                </div>
             
                <div v-if="selectedPage.header_name" class="col-lg-4 col-xl-3 align-self-center mb-2">

                  <b-form-group>
                    <div class="input-material mt-2">
                      <b-form-input
                        type="text"
                        v-model="item.header_name"
                        id="bannerURL"
                        placeholder="Sub Header"
                      ></b-form-input>
                      <label>Header Name</label>
                    </div>
                  </b-form-group>
                </div>
                <div  class="col-lg-12 col-xl-12 align-self-center mb-2"></div>
              </div>
              <div class="mb-1">
                <div v-if="selectedPage.description" class="col-lg-12 col-xl-12 align-self-center mb-2">
                  <b-form-group>
                    <div class=" input-material mt-2 w-100">
                      <textarea
                      class="form-control rounded-5"
                        type="text"
                        v-model="item.description"
                      ></textarea>
                      <label>Description</label>
                    </div>
                  </b-form-group>
                </div>
              </div>
              <div class="d-flex mt-1 pt-2">
            
                <b-col v-if="selectedPage.image" sm="4" class="mt-2" >
                  <b-form-group class="mt-2">
                    <label for="logo">
                     image:- {{item.isImageUpload}}
                      <br />Size: 174*309
                    </label>
                    <div v-if="item.isImageUpload" class="spinner-border text-secondary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <b-form-file
                    v-else
                      ref="fileinput"
                      v-on:change="
                        uploadImageHandler(
                          $event.target,
                          'images',
                          { w: 174, h: 309 },
                          index
                        )
                      "
                      accept="image/jpeg, image/png, image/gif"
                      :plain="true"
                      multiple
                    ></b-form-file>

                    <input type="hidden" v-model="item.images" />
                  </b-form-group>
                  <div
                    style="cursor: pointer"
                    @click="seeImagesFill('images', index,'image')"
                    v-if="item.images"
                  >
                    <u
                      >See
                      {{ item.images.split && item.images.split(",").length }}
                      images</u
                    >
                  </div>
                </b-col>
                <b-col v-if="selectedPage.cover_image" sm="4" class="mt-2">
                  <b-form-group class="mt-2">
                    <label for="logo">
                      Cover Image
                      <br />Size: 174*309
                    </label>
                    <div v-if="item.isCoverImageUpload"class="spinner-border text-secondary" role="status">
                     <span class="sr-only">Loading...</span>
                  </div>
                    <b-form-file
                    v-else
                      ref="fileinput"
                      v-on:change="
                        uploadImageHandler(
                          $event.target,
                          'cover_image',
                          { w: 174, h: 309 },
                          index
                        )
                      "
                      accept="image/jpeg, image/png, image/gif"
                      :plain="true"
                    ></b-form-file>
                    
                    <input type="hidden" v-model="item.cover_image" />
                  </b-form-group>
                  <div
                    style="cursor: pointer"
                    @click="seeImagesFill('cover_image', index,'image')"
                    v-if="item.cover_image"
                  >
                    <u>See {{ item.cover_image.split(",").length }} images</u>
                  </div>
                </b-col>
                <b-col v-if="selectedPage.video_url" sm="4" class="mt-2">
                  <b-form-group class="mt-2">
                    <label for="logo">
                      Video
                      <br />
                    </label>
                    <div v-if="item.isVideoUpload"class="spinner-border text-secondary" role="status">
                     <span class="sr-only">Loading...</span>
                  </div>
                    <b-form-file
                    v-else
                      ref="fileinput"
                      v-on:change="
                        uploadImageHandler(
                          $event.target,
                          'video_url',
                          { w: 174, h: 309 },
                          index
                        )
                      "
                      accept="video/mp4, video/webm, video/ogg"
                      :plain="true"
                    ></b-form-file>
               
                    <input  type="hidden" v-model="item.video_url" />
                  </b-form-group>
                  <div
                    style="cursor: pointer"
                    @click="seeImagesFill('video_url', index,'video')"
                    v-if="item.video_url"
                  >
                    <u>See {{ item.video_url.split(",").length }} video</u>
                  </div>
                </b-col>
              </div>
             
               
           
                <b-col sm="1" style="margin-top: 2%">
                  <i
                    v-if="index == 0"
                    style="margin-top: 1rem"
                    class="fa fa-plus-square-o text-success mt-3 mx-2"
                    @click="addBannerFormat"
                  ></i>
                  <i
                    v-else
                    style="margin-top: -15px"
                    class="fa fa-minus-square-o text-danger mx-2"
                    @click="removeBannerImage(index)"
                  ></i>
                </b-col>
              </div>
            </b-row>

            <b-row
              class="m-2"
              v-if="
                $can('create', 'List Of Pages') ||
                $can('update', 'List Of Pages')
              "
            >
              <b-col sm="4">
                <b-button type="submit" size="sm" variant="primary">
                  <i class="fa fa-dot-circle-o"></i>
                  {{ staticNames.name }}
                </b-button>
              </b-col>
              <b-col sm="4">
                <b-button
                  @click="resetStaticBanner"
                  size="sm"
                  variant="success"
                >
                  <i class="fa fa-dot-circle-o"></i> Reset
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <div>
      <b-modal
        id="modalPopover"
        title="See Images"
        ref="showImages"
        @ok="onOkay"
      >
        <div>
          <draggable
            v-model="bannerImg"
            class="d-flex justify-content-center flex-wrap"
            group="image"
            @start="drag = true"
            @end="drag = false"
          >
            <div
              sm="4"
              v-for="(item, index) in bannerImg"
              :key="index"
              class="m-2"
            >
              <img
              v-if="fileType=='image'"
                :src="_GetImagePath(item)"
                style="width: 100px; height: 100px"
              />
              <p  style="width: 400px; height: 100px"
              v-else>{{item}}</p>
              <div class="m-2">
                <button class="btn-blue" @click="removeImagesFill(index)">
                  Remove
                </button>
              </div>
            </div>
          </draggable>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal
        id="redirectModal"
        ref="redirectModal"
        @ok="handleRedirect"
        title="Record Found"
        class="center-footer"
        footer-class="justify-content-center border-0"
        cancel-variant="outline-danger"
        ok-variant="outline-success"
        centered
        hide-header
        no-close-on-esc
        no-close-on-backdrop
      >
        <div class="d-block text-center">
          <div>
            Record with same name and language found. Edit from view list pages.
          </div>
        </div>
      </b-modal>
    </div>
    <b-modal
      id="ModalConfirmationOnSubmit"
      ref="ModalConfirmationOnSubmit"
      @ok="handleModalOkay"
      :title="modalObject.title"
      class="center-footer"
      footer-class="justify-content-center border-0"
      cancel-variant="outline-danger"
      ok-variant="outline-success"
      centered
      hide-header
      no-close-on-esc
      no-close-on-backdrop
    >
      <div class="d-block text-center">
        <div>{{ modalObject.message }}</div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import MasterService from "@/services/MasterService";
import ExhibitorService from "@/services/ExhibitorService";
import { BASEURL, IMGBASEURL } from "@/config/index";

export default {
  name: "ListOfPages",
  data() {
    return {
      isLoader:false,
      isUpload:false,
      fileType:"image",
      bannerType: "",
      bannerIndex: "",
      BaseURL: "",
      staticNames: {
        name: "Add",
      },
      modalObject: {
        title: "fdsfds",
      },
      selectedPage:{module:"",banner:true,main_name:true,header_name:true,description:true,image:true,cover_image:true,video_url:true,name:"Main name"},
      cinemaListArray: [],
      LanguageArray: [],
      pagesList: {
        mpm_id: "",
        main_name: "",
        lang_id: 0,
        banner: "",
        status: "Y",
        otherData: [
          {
            mpm_d_id: "",
            main_name: "",
            header_name: "",
            description: "",
            images: "",
            cover_image: "",
            video_url:"",
            o_status: "Y",
          },
        ],
      },
      updateList: {
        mpm_id: "",
        main_name: "",
        lang_id: 0,
        banner: "",
        status: "Y",
        otherData: [
          {
            mpm_d_id: "",
            main_name: "",
            header_name: "",
            description: "",
            images: "",
            cover_image: "",
            video_url:"",
            o_status: "Y",
          },
        ],
      },
      staticBanner: {
        appthumbimage: "",
        selectedMovieBanner: [],
        desktopbanner: "",
        LanguageID: "",
        appbanner: "",
        youtube: "",
        BannerIsActive: true,
        Flag: 1,
        id: "",
        pagename: "",
        active: true,
        banners: "",
        otherdata: [
          {
            header: "",
            header1: "",
            description: "",
            images: "",
            coverimage: "",
            video_url:"",
            isImageUpload:false,
            isVideoUpload:false,
          },
        ],
      },

      getBannerDetails: [],
      moviesList: [],
      SeeImages: [],
      pageList: [
        "premiere",
        "branches",
        "showTimes",
        "expe",
        "foodMenu",
        "cinemaOffer",
        "privateBooking",
        "updatePage",
        "AdvertiseWithUs",
        "FAQs",
        "WhatsappCommunity"
      ],
      moduleTagsList:[
      {module:"premiere",banner:true,main_name:true,header_name:true,description:true,image:true,cover_image:true,video_url:true,name:"Main name"},
      {module:"branches",banner:true,main_name:true,header_name:true,description:true,image:true,cover_image:true,video_url:true,name:"Main name"},
      {module:"showTimes",banner:true,main_name:true,header_name:true,description:true,image:true,cover_image:true,video_url:true,name:"Main name"},
      {module:"expe",banner:true,main_name:true,header_name:true,description:true,image:true,cover_image:true,video_url:true,name:"Main name"},
      {module:"foodMenu",banner:true,main_name:true,header_name:true,description:true,image:true,cover_image:true,video_url:true,name:"Main name"},
      {module:"cinemaOffer",banner:true,main_name:true,header_name:true,description:true,image:true,cover_image:true,video_url:true,name:"Main name"},
      {module:"privateBooking",banner:true,main_name:true,header_name:true,description:true,image:true,cover_image:true,video_url:true,name:"Main name"},
        {module:"updatePage",banner:false,main_name:true,header_name:false,description:true,image:true,cover_image:false,video_url:true,name:"Header"},
        {module:"AdvertiseWithUs",banner:false,main_name:true,header_name:false,description:true,image:true,cover_image:false,video_url:false,name:"Header"},
        {module:"FAQs",banner:false,main_name:true,header_name:false,description:true,image:false,cover_image:false,video_url:false,name:"Quation"},
        {module:"WhatsappCommunity",banner:false,main_name:true,header_name:false,description:true,image:true,cover_image:false,video_url:false,name:"Cinema"},
      ],
      imagesVmodel: "",
      imagesIndex: "",
      bannerImg: [],
      selectedLang: null,
      getAllPagesList: [],
      checkData: [],
      checkStatus: false,
      mpmId: null,
      IMGBASEURL: IMGBASEURL,
    };
  },
  components: {
    draggable,
  },
  computed: {},
  watch: {},
  beforeMount() {
    const { movieId, mpm_id } = this.$route.query;

    if (mpm_id) {
      this.getLanguagesList().then(() => {
        this.getListOfPages();
      });

      this.staticNames.name = "Update";
    } else {
      this.getLanguagesList();
    }
  },
  mounted: function () {
    this.getListOfPages();
    this.getLanguagesList();
  },
  methods: {
    handleRedirect() {
      console.log("redirect");
    },
    onOkay() {
      console.log("okay clicked");
      if (this.imagesIndex < 0) {
        this.pagesList[this.bannerType] = this.bannerImg.join(",");
      } else {
        this.pagesList.otherData[this.bannerIndex][this.bannerType] =
          this.bannerImg.join(",");
      }
    },
    seeImagesFill(model_name, index,type) {
      this.imagesIndex = index;
      this.fileType=type
      this.imagesVmodel = model_name;
      this.bannerType = model_name;
      this.bannerIndex = index;
      if (this.imagesIndex < 0) {
        this.bannerImg = this.pagesList[this.imagesVmodel].split(",");
      } else {
        this.bannerImg =
          this.pagesList.otherData[this.imagesIndex][this.imagesVmodel].split(
            ","
          );
      }
      console.log(this.bannerImg, "seeImages");
      this.$refs.showImages.show();
    },
    removeImagesFill(index) {
      this.bannerImg.splice(index, 1);

      if (this.imagesIndex < 0) {
        this.pagesList[this.imagesVmodel] = this.bannerImg.join(",");
      } else {
        this.pagesList.otherData[this.imagesIndex][this.imagesVmodel] =
          this.bannerImg.join(",");
      }

      console.log(this.staticBanner[this.imagesVmodel], "fsddfsdfsdfsd");
      this.showMessageSnackbar("Image Removed Successfully");
      this.$refs.showImages.hide();
    },
    onSelectPage (page){
      console.log("this.onSelectPage",page)
     let pageName=this.pageList.main_name || page || ""
     let filterModule=this.moduleTagsList.filter(ele=>ele.module==pageName)
     if(filterModule.length>0){
      this.selectedPage=filterModule[0]
     }
     else{
      this.selectedPage= {module:"",banner:true,main_name:true,header_name:true,description:true,image:true,cover_image:true,video_url:true,name:"Main name"}
      }
    },
    addBannerFormat() {
      let obj = {
        main_name: "",
        header_name: "",
        description: "",
        images: "",
        cover_image: "",
        video_url:"",
        isImageUpload:false,
        isVideoUpload:false,
        isCoverImageUpload:false,
        o_status: "Y",
      };
      this.pagesList.otherData.push(obj);
    },
    removeBannerImage(index) {
      this.pagesList.otherData[index]["o_status"] = "N";
    },

    languageSelect: function (languageList) {
      // this.pagesList.lang_id = languageList.lang_id;
      if (this.pagesList.main_name) {
        this.checkData = this.getAllPagesList.filter((x) => {
          return (
            x.mpm_name == this.pagesList.main_name &&
            x.mpm_lang_id == languageList.lang_id
          );
        });
        if (this.checkData.length > 0) {
          this.mpmId = this.checkData[0].mpm_id ? this.checkData[0].mpm_id : "";
          this.$bvModal.show("redirectModal");
          this.checkStatus = true;
        }
      } else {
        console.log("this.checkData from else", this.checkData);
      }
    },
    getLanguagesList: function () {
      let payload = {
        tableName: "ms_language",
        lang_is_active: "Y",
      };
      return MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            console.log("langres", data.Records);
            this.LanguageArray = data.Records;
          } else {
            console.log("Error from language", data.message);
          }
        })
        .catch((error) => {
          console.log(error, "from language catch");
        });
    },
    getCinemaListById: function () {
      let payload = {
        OrgID: 0,
      };
      CinemaService.getCinemas(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.Status && data.CinemaList.length > 0) {
            console.log(data.CinemaList);
            this.cinemaListArray = data.CinemaList.filter((x) => {
              return x.CinemaIsActive;
            });
            this.cinemaListArray.unshift({
              CinemaChargesID: null,
              CinemaID: "0",
              CinemaName: "All",
              ThumbnailImage: "0",
              Address: "HO",
              OrganizationID: "1",
              Phone: "HO",
              Email: "0",
              Location: "RIYADH",
              CountryID: "230",
              StateID: "0",
              DataProviderID: "0",
              DataProviderCinemaID: "0",
              CityID: "1",
              Pincode: "0",
              Latitude: "0",
              Longitude: "0",
              No_of_Schedules: "0",
              Booking_CutoffTime: "0",
              SCExpiry: "00",
              Booking_Max_No_Seats: "0",
              CinemaIsActive: false,
              Flag: 0,
              BaseURL: "https://apinew.empirecinemas.com/",
            });

            if (this.getBannerDetails.length > 0) {
              let cinemaIdArrayList = [];
              this.getBannerDetails[0].CinemaID.map((y) => {
                let objNew = this.cinemaListArray.filter((x) => {
                  return x.CinemaID == y;
                })[0];
                console.log(objNew, "fsdfsdf");
                cinemaIdArrayList.push(objNew);
              });
              this.staticBanner.CinemaIDArray = cinemaIdArrayList;
            }
          } else {
            this.showMessageSnackbar(data.Message);
          }
        })
        .catch((error) => {
          this.showMessageSnackbar(
            "Oops! Something went wrong. kindly contact your administrator"
          );
        });
    },
    selectAllCinema: function (cinemaList) {
      if (cinemaList.CinemaName == "All") {
        setTimeout((x) => {
          this.staticBanner.CinemaIDArray = this.cinemaListArray.filter((x) => {
            return parseInt(x.CinemaID) > 0;
          });
        }, 100);
      }
    },
    getBannersDetails: function (pageid) {
      let payload = {
        pageid,
      };

      MasterService.getPageViewById(payload)
        .then((response) => {
          const { data } = response;
          if (data.Status) {
            this.BaseURL = data.BaseURL;
            Object.keys(data.PageList).map((x) => {
              console.log(x);
              if (this.staticBanner.hasOwnProperty(x)) {
                if (x == "banners") {
                  this.staticBanner[x] = data.PageList[x].join(",");
                } else if (x == "otherdata") {
                  data.PageList[x].map((z) => {
                    z["images"] =
                      z["images"].length > 0 ? z["images"].join(",") : "";
                  });
                  console.log(data.PageList[x], "fsfsdfs33333df");
                  this.staticBanner["otherdata"] = data.PageList[x];
                } else {
                  this.staticBanner[x] = data.PageList[x];
                }
              }
            });

            this.getBannerDetails = [data.PageList];
            this.getLanguagesList();
          } else {
            this.showMessageSnackbar(data.Message);
          }
        })
        .catch((error) => {
          console.log("Catch on Banner-getBannerByID Error: ", error);
          this.showMessageSnackbar(
            "Oops! Something went wrong. kindly contact your administrator"
          );
        });
    },
    submitStaticBanner: function () {
      if (!this.staticBanner.pagename) {
        this.showMessageSnackbar("Please Select Any Movie");
      } else if (!this.staticBanner.LanguageID) {
        this.showMessageSnackbar("Please Select Any Language");
      } else if (!this.staticBanner.banners) {
        this.showMessageSnackbar("Please Select Banner Image");
      } else {
        let payload = {
          title: "Confirmation",
          message: "Please re-check the data before submit",
        };
        this.showSubmitConfirmation(payload);
      }
    },

    uploadAppThumbBanner: function (image) {
      let refs = this.$refs;
      var self = this;
      var _URL = window.URL || window.webkitURL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = async function () {
          var formdata = new FormData();
          formdata.append("assets/images/movies/banners", image.files[0]);
          UploadService.uploadFiles(formdata)
            .then((response) => {
              response.data.Message
                ? self.showMessageSnackbar(response.data.Message)
                : "";

              if (response.data.Status) {
                self.staticBanner.appthumbimage = response.data.Path;
                self.BaseURL = response.data.BaseURL;
              }
            })
            .catch((error) => {
              console.log("Catch on AddStaticImages-onUpload Error: ", error);
              self.showMessageSnackbar(
                "Oops! Something went wrong. kindly contact your administrator"
              );
            });
        };
      }
    },

    uploadMobileBanner: function (image) {
      let refs = this.$refs;
      var self = this;
      var _URL = window.URL || window.webkitURL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = async function () {
          var formdata = new FormData();
          formdata.append("assets/images/movies/banners", image.files[0]);
          UploadService.uploadFiles(formdata)
            .then((response) => {
              response.data.Message
                ? self.showMessageSnackbar(response.data.Message)
                : "";

              if (response.data.Status) {
                self.staticBanner.appbanner = response.data.Path;
                self.BaseURL = response.data.BaseURL;
              }
            })
            .catch((error) => {
              console.log("Catch on AddStaticImages-onUpload Error: ", error);
              self.showMessageSnackbar(
                "Oops! Something went wrong. kindly contact your administrator"
              );
            });
          //  }
        };
      }
    },
    resetStaticBanner: function () {
      if (this.staticBanner.BannerID) {
        window.location.replace(
          window.location.origin + "/" + window.location.hash.split("?")[0]
        );
      }
      this.staticBanner = {
        appthumbimage: "",
        selectedMovieBanner: [],
        desktopbanner: "",
        LanguageID: [],
        appbanner: "",
        youtube: "",
        BannerIsActive: true,
        Flag: 1,
      };
      this.BaseURL = "";
      this.$refs["fileinput"].reset();
    },
    // Show Confirmmation Dialog
    handleModalOkay: function (evt) {
      this.modalObject.count = 1;
      this.submitFinalData();
    },
    showSubmitConfirmation: function (payload) {
      this.modalObject.title = payload.title; // "Confirmation";
      this.modalObject.message = payload.message; // "Please re-check the data before submit";
      this.openModal("ModalConfirmationOnSubmit");
    },
    openModal: function (ref) {
      this.$refs[ref].show();
    },
    closeModal: function (ref) {
      this.$refs[ref].hide();
      this.modalObject.title = ""; // "Confirmation";
      this.modalObject.message = ""; // "Please re-check the data before submit";
    },
    // Show Confirmmation Dialog End
    // Show Error Message
    showMessageSnackbar: function (Message) {
      let x = document.getElementById("snackbar");
      x.className = "show";
      x.innerHTML = Message;
      setTimeout(function () {
        x.className = x.className.replace("show", "");
      }, 3000);
    },
    uploadBanner: function (image) {
      let currImagesArr = this.getSafe(
        () => this.pagesList.banner.split(","),
        []
      );
      console.log(image.files);
      let refs = this.$refs;
      var self = this;
      var _URL = this.BASE_URL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();
        // img.src = `${_URL}/${file.name}`;
        console.log("img_src", img.src);
        let img_data = "";
        var files = image.files;

        const formData = new FormData();
        for (const i of Object.keys(files)) {
          console.log("imagesformdata", `${_URL}/uploads/${files[i].name}`);
          formData.append("image_arr", files[i]);
        }
        ExhibitorService.MultipleImages(formData)
          .then((response) => {
            console.log(response);
            const { data } = response;
            this.bannerImg = [...currImagesArr, ...data.path];
            this.pagesList.banner = this.bannerImg.toString();

            console.log(this.pagesList.banner, "bannerImg");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    uploadImageHandler: function (image, name, size, index) {
      let currImagesArr = this.getSafe(
        () => this.pagesList.otherData[index][name].split(","),
        []
      );
      console.log(image.files);
      let refs = this.$refs;
      var self = this;
      var _URL = this.BASE_URL;
      var file, img;
      if ((file = image.files[0])) {
        img = new Image();
        // img.src = `${_URL}/${file.name}`;
        console.log("img_src", img.src);
        let img_data = "";
        var files = image.files;

        const formData = new FormData();
        for (const i of Object.keys(files)) {
          console.log("imagesformdata", `${_URL}/uploads/${files[i].name}`);
          formData.append("image_arr", files[i]);
        }
        if(name=='video_url'){
          this.pagesList.otherData[index]["isVideoUpload"]=true;
          console.log("check 1",)
        }
        else if(name=="cover_image"){
          console.log("check 2")

          this.pagesList.otherData[index]["isCoverImageUpload"]=true;
        }
        else{
          console.log("check 3")

          this.pagesList.otherData[index]["isImageUpload"]=true;

        }
   console.log("check=>",this.pagesList.otherData[index])
        ExhibitorService.MultipleImages(formData)
          .then((response) => {
            console.log(response);
            const { data } = response;
            this.bannerImg = [...currImagesArr, ...data.path];
            this.pagesList.otherData[index][name] = this.bannerImg.toString();
           
            this.pagesList.otherData[index].isVideoUpload=false;
            this.pagesList.otherData[index].isImageUpload=false;
            this.pagesList.otherData[index].isCoverImageUpload=false;

            console.log(this.pagesList.otherData[index][name], "bannerImg");
          })
          .catch((error) => {
            console.log(error);
            this.pagesList.otherData[index].isVideoUpload=false;
            this.pagesList.otherData[index].isImageUpload=false;
            this.pagesList.otherData[index].isCoverImageUpload=false;


          });
      }
    },
    getListOfPages() {
      let loader = this.$loading.show();

      if (this.$route.query.mpm_id) {
        let payload = `?mpm_id=${this.$route.query.mpm_id}`;
        ExhibitorService.GetListOfPages(payload)
          .then((response) => {
            const { data } = response;
            let modifyData=[]
            let dataArray=data.Records && data.Records.otherData.length? data.Records.otherData:[{
              main_name: "",
        header_name: "",
        description: "",
        images: "",
        cover_image: "",
        video_url:"",
        isImageUpload:false,
        isVideoUpload:false,
        isCoverImageUpload:false,
        o_status: "Y",
            }];
            if(dataArray.length){
              modifyData=dataArray.map((ele)=>{
                return {
                  ...ele,
                  isImageUpload:false,
                  isCoverImageUpload:false,
                  isVideoUpload:false,
                }
              })
            }
            this.pagesList ={ ...data.Records,otherData:modifyData};
            
         this.onSelectPage(this.pagesList.main_name || "")

            this.pagesList.banner = this.pagesList.banner.length
              ? this.pagesList.banner.replace(/([^:]\/)\/+/g, "$1")
              : this.pagesList.banner;
            let selectedLangId = data.Records.lang_id;
            console.log("dataLang", data.Records.lang_id);
            let selectedLang = this.LanguageArray.filter((l) => {
              return l.lang_id == selectedLangId;
            });

            if (selectedLang.length) {
              this.selectedLang = selectedLang;
            }
          
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      } else {
        ExhibitorService.GetListOfPages()
          .then((response) => {
            const { data } = response;
            this.getAllPagesList = data.Records;
            console.log("getlist", this.getAllPagesList);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },
    submitFinalData() {
      let loader = this.$loading.show();

      let testArr = [];
      if (this.pagesList.banner && this.pagesList.banner.length) {
        let temp = [];
        this.pagesList.banner
          .split(",")
          .map((x) => x.trim())
          .filter(Boolean)
          .forEach((i) =>
            i.startsWith("http") ? temp.push(new URL(i).pathname) : temp.push(i)
          );
        this.pagesList.banner = temp.join(",");
      }
      if (this.selectedLang != null) {
        this.pagesList.lang_id = this.selectedLang.lang_id;
      }
      testArr.push(this.pagesList);
      let payload = {
        pagesList: testArr,
      };
      ExhibitorService.AddListOfPages(payload)
        .then((response) => {
          const { data } = response;
          this.$toasted.show(data.message);
          this.$router.go(-1);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
  },
  updated() {},
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/listOfPages.vue